export default __webpack_public_path__ + "static/media/459.d019ca3a.gif";